import React, { Component } from 'react';

export default class Loader extends Component {
  render() {
    return <i className="fal fa-spin fa-spinner-third brand-red absolute-center" />;
  }
}



// WEBPACK FOOTER //
// ./src/components/loader/loader.jsx